<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 15,
      height: 15,
      color: 'currentColor',
      viewBoxValue: `0 0 15 15`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M9.33329 1.51303V4.26673C9.33329 4.64009 9.33329 4.82678 9.40595 4.96938C9.46987 5.09483 9.57186 5.19681 9.6973 5.26073C9.83991 5.33339 10.0266 5.33339 10.4 5.33339H13.1537M5.99996 10.6667L7.33329 12L10.3333 9.00001M9.33329 1.33334H5.86663C4.74652 1.33334 4.18647 1.33334 3.75864 1.55133C3.38232 1.74308 3.07636 2.04904 2.88461 2.42536C2.66663 2.85319 2.66663 3.41324 2.66663 4.53334V11.4667C2.66663 12.5868 2.66663 13.1468 2.88461 13.5747C3.07636 13.951 3.38232 14.2569 3.75864 14.4487C4.18647 14.6667 4.74652 14.6667 5.86663 14.6667H10.1333C11.2534 14.6667 11.8134 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1153 13.5747C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V5.33334L9.33329 1.33334Z"
      stroke="#667085"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
